import React from "react";
import FormsDownloadLink from "../components/FormsDownloadLink";
import FormsHeading from "../components/FormsHeading";
import "./forms.css";

/**
 * Forms Page
 * This page is purposefly for downloading all forms data
 * @returns a JSX element containing components to make a complete page
 */

function Forms() {
  return (
    <div className="Forms">
      <div className="Forms_Highlight">
        <div>
          <h1>FORMS DOWNLOAD</h1>
          {/* <p>Lorem ipsum dolor sit amet, consectetur <br /> adipiscing  elit, sed do eiusmod tempor <br /> incididunt ut labore et dolore magna aliqua.</p> */}
        </div>
      </div>
      <div className="Forms_Downloads">
        <div>
          <div>
            <FormsHeading text="Proposal Forms" />
          </div>
          <div className="Forms_DownloadLinks">
            <FormsDownloadLink 
              text="Motor Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/MOTOR INSURANCE PROPOSAL FORM.pdf")}
            />
            <FormsDownloadLink 
              text="Fire Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Fire proposal insurance.pdf")}
            />
            <FormsDownloadLink 
              text="Goods-In-Transit" 
              downloadUrl={require("../Forms/Proposal Forms/PROPOSAL FORM FOR GOODS IN TRANSIT.pdf")}
            />
            <FormsDownloadLink 
              text="Travel Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/TRAVEL INSURANCE PROPOSAL FORM.pdf")}
            />
            <FormsDownloadLink 
              text="Marine Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/MARINE CARGO INSURANCE PROPOSAL FORM 2.pdf")}
            />
            <FormsDownloadLink 
              text="Machinery Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Machinery breakdown insurance proposal form .pdf")}
            />
            <FormsDownloadLink 
              text="Contractors all risk" 
              downloadUrl={require("../Forms/Proposal Forms/Proposal form for Contractors all Risks.pdf")}
            />
            <FormsDownloadLink 
              text="Burglary Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Burglary insurance proposal form.pdf")}
            />
            <FormsDownloadLink 
              text="Commercial Vehicle Motor" 
              downloadUrl={require("../Forms/Proposal Forms/Commercial Vehicle Motor Proposal New.pdf")}
            />
            <FormsDownloadLink 
              text="Employers Liability Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Employers liability insurance proposal form.pdf")}
            />
            <FormsDownloadLink 
              text="Marine Hull Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/MARINE INS PROPOSAL FORM HULL.pdf")}
            />
            <FormsDownloadLink 
              text="Professional Indemnity Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Professional indemnity insurance proposal form 2.pdf")}
            />
            <FormsDownloadLink 
              text="Public Liability Insurance" 
              downloadUrl={require("../Forms/Proposal Forms/Public liability proposal form general premises risk.pdf")}
            />
          </div>
        </div>
        <div>
          <div>
            <div>
              <FormsHeading text="Claim Forms" />
            </div>
            <div className="Forms_DownloadLinks">
              <FormsDownloadLink 
                text="Motor Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Motor claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Fire Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Fire insurance claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Goods-In-Transit" 
                downloadUrl={require("../Forms/Claim Forms/Goods in transit claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Travel Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Travel insurance policy claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Marine Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Marine insurance cargo claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Machinery Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Machinery Breakdown insurance claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Contractors all risk" 
                downloadUrl={require("../Forms/Claim Forms/Contractors all risk claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Burglary Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Burglary claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Employers Liability Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Employers liability claim form .pdf")}
              />
              <FormsDownloadLink 
                text="Marine Hull Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Marine hull claim form.pdf")}
              />
              <FormsDownloadLink 
                text="Professional Indemnity Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Professional indemnity insurance claim form .pdf")}
              />
              <FormsDownloadLink 
                text="Public Liability Insurance" 
                downloadUrl={require("../Forms/Claim Forms/Public liability claim form .pdf")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forms;
